export const environment = {
  api: 'https://dev.api.sondis.at/api',
  chat: 'https://sondisa.sondis.karli.ai/de',
  // api: 'http://localhost:8080/api'
};
